import type { DbTagRow } from '../../resolution/types.js';
import type { CodeNavLocation } from '../../types.js';

export const TAG_SELECT = `file_path, name, role, kind, start_line, start_column, end_line, end_column,
  scope_start_line, scope_start_column, parent_scope_start_line, parent_scope_start_column, nav_target_path, scope_chain`;

export function rowToLocation(row: DbTagRow): CodeNavLocation {
  return {
    path: row.file_path,
    line: row.start_line + 1,
    column: row.start_column,
    kind: row.kind,
    role: row.role === 'def' ? 'definition' : 'reference',
  };
}

export function modulePathLocation(row: DbTagRow): CodeNavLocation {
  return {
    path: row.nav_target_path!,
    line: 1,
    column: 0,
    kind: 'module',
    role: 'reference',
  };
}

export function emptyRefRow(filePath: string): DbTagRow {
  return {
    file_path: filePath,
    name: '',
    role: 'ref',
    kind: '',
    start_line: 0,
    start_column: 0,
    end_line: 0,
    end_column: 0,
    scope_start_line: null,
    scope_start_column: null,
    parent_scope_start_line: null,
    parent_scope_start_column: null,
    nav_target_path: null,
    scope_chain: null,
  };
}
